import { yupResolver } from '@hookform/resolvers/yup'
import AOS from 'aos'
import axios from 'axios'
import ContactUsSection from 'components/ServicePage/ContactUsSection'
import dynamic from 'next/dynamic'
import Router, { useRouter } from 'next/router'
import { FC, useEffect, useState } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'
import { isValidPhoneNumber } from 'react-phone-number-input'
import * as yup from 'yup'

const ContactModal = dynamic(() => import('components/ContactModal'), {
  ssr: false,
})

const BannerSec = dynamic(() => import('components/Common/BannerSec'), {
  ssr: false,
})
const HireDevelopers = dynamic(
  () => import('components/HomePage/HireDevelopers'),
  {
    ssr: false,
  }
)
const FaqSection = dynamic(() => import('components/ServicePage/FaqSection'), {
  ssr: false,
})
const ContactInformation = dynamic(
  () => import('components/HomePage/ContactInformation'),
  {
    ssr: false,
  }
)
const CenterTitleSec = dynamic(() => import('./CenterTitleSec'), {
  ssr: false,
})
const TechnologyCard = dynamic(() => import('./TechnologyCard'), {
  ssr: false,
})
const Best = dynamic(() => import('./Best'), {
  ssr: false,
})
type FormValues = {
  yourName: string
  yourEmail: string
  phoneInput: string
  skypeID: string
  projectRequirements: string
}
const TechnologyPage: FC<{ data }> = ({ data }) => {
  const [show, setShow] = useState(false)
  const formModalhandleClose = () => setShow(false)
  const formModalhandleShow = () => setShow(true)

  const schema = yup.object().shape({
    yourName: yup.string().max(80).trim().required('Your Name is required'),
    yourEmail: yup
      .string()
      .email('Invalid email format')
      .max(255)
      .required('Your Email is required'),
    projectRequirements: yup
      .string()
      .trim()
      .required('Your Project Requirements is required'),
    phoneInput: yup
      .string()
      .test('isValidPhoneNumber', 'Invalid phone number', (value) =>
        value ? isValidPhoneNumber(value) : true
      ),
  })
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
  } = useForm<FormValues>({
    resolver: yupResolver(schema),
  })

  const [SuccessMesg, setSuccessMesg] = useState('')
  const [ErrorMesg, setErrorMesg] = useState('')

  const router = useRouter()
  const PageUrl = router.query.path
    ? router.query.path
    : router.pathname.split('/')[1]
  const [phoneCountryCode, setPhoneCountryCode] = useState()
  const [formCountryName, setFromCountryName] = useState()

  const onSubmit: SubmitHandler<FormValues> = (dataFetch) => {
    setSuccessMesg('')
    setErrorMesg('')
    const newComment = {
      name: dataFetch.yourName,
      email: dataFetch.yourEmail,
      skypeId: dataFetch.skypeID,
      contactNumber: dataFetch.phoneInput,
      pro_requirements: dataFetch.projectRequirements,
      pageName: PageUrl,
      countryName: formCountryName,
    }

    fetch(`${process.env.NEXT_PUBLIC_API_URL}/api/user/contactUs/sendInquiry`, {
      method: 'POST',
      headers: new Headers({
        Accept: 'application/json',
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(newComment),
    })
      .then((response) => response.json())
      .then(({ code }) => {
        if (code === 200) {
          setSuccessMesg('Thank you for your message. It has been sent.')

          setTimeout(() => {
            Router.push('/thank-you')
          }, 100)
        } else {
          setErrorMesg(data.message)
        }
      })
      .catch((error) => {
        setErrorMesg('Please try again after sometime')
      })
  }

  const PageUrlCheck = router.pathname === '/technology'

  const fetchIpLocation = () => {
    ;(async () => {
      await axios.get(`https://ipapi.co/json/`).then((response) => {
        setPhoneCountryCode(response.data.country_code)
        setFromCountryName(response.data.country_name)
      })
    })()
  }
  // useEffect(() => {
  //   const timer = setTimeout(formModalhandleShow, 40000)
  //   return () => clearTimeout(timer)
  // }, [])
  useEffect(() => {
    fetchIpLocation()
    AOS.init()
  }, [])
  const [contactPopup, setContactPopup] = useState(false)

  return (
    <>
      <BannerSec
        bannerimg="/assets/images/banner-inner-technology.svg"
        blueTitle="Technology"
        blueTitle2=""
        title="Stack"
        subTitle="WebClues helps businesses build and deploy performant mobile and web applications with robust, advanced, and emerging technologies."
        blueButtonText1="Get"
        buttonText2="Consultation"
        bannerCtaUrl="/get-quote"
        altTag="Technology Stack"
      />
      <CenterTitleSec
        title="Speed up Development Process with Modern Tech Arena"
        subTitle="We use the most relevant and efficient technology infrastructure to build and deploy your mobile or web applications. With our experience and ability to choose the best tech stack for your solution, you can easily steam ahead of the competition."
        textPosition="text-center justify-content-center"
        colWidth={7}
      />
      <TechnologyCard />
      <Best
        setContactPopup={setContactPopup}
        data={{
          title: 'What’s So Special About WebClues?',
          subTitle: [
            'Our experience, understanding of the industry, and innovative approach make us the only development team you will need for all sorts of projects. We are known for the mobile app development technologies utilized and how we leverage the platform-specific functionalities to build your solution generating stellar results.',
          ],
          img: '/assets/images/technology/best-technology.jpg',
          box: [
            {
              Icontitle: 'Detailed analysis',
              iconimg: '/assets/images/best/b1.svg',
            },
            {
              Icontitle: 'Aesthetic Designs',
              iconimg: '/assets/images/best/b2.svg',
            },
            {
              Icontitle: 'Rigorous Testing',
              iconimg: '/assets/images/best/b4.svg',
            },
            {
              Icontitle: 'Swift Deployment',
              iconimg: '/assets/images/best/b5.svg',
            },
            {
              Icontitle: 'Smooth Handover',
              iconimg: '/assets/images/best/b6.svg',
            },
            {
              Icontitle: 'Aligned Structure',
              iconimg: '/assets/images/best/b7.svg',
            },
            {
              Icontitle: 'Domain Expertise',
              iconimg: '/assets/images/best/b9.svg',
            },
            {
              Icontitle: 'On time Delivery',
              iconimg: '/assets/images/best/b11.svg',
            },
            {
              Icontitle: '24/7 Support',
              iconimg: '/assets/images/best/b12.svg',
            },
            {
              Icontitle: 'Agile Development',
              iconimg: '/assets/images/best/b3.svg',
            },
            {
              Icontitle: 'Distinct Competitors',
              iconimg: '/assets/images/best/b8.svg',
            },
            {
              Icontitle: 'Advance Infrastructure',
              iconimg: '/assets/images/best/b10.svg',
            },
          ],
        }}
      />
      <div className="pb-120px">
        <HireDevelopers
          className=""
          data={{
            title: 'Hire Technology Experts for',
            bluetitle: 'Your Business',
            img: '/assets/images/hire-dev-img.jpg',
            desc: 'WebClues has in-house design and development experts ready to work on your projects dedicatedly for the full eight hours until the work is done as per your satisfaction. Working with us means having a solution that is built with the latest mobile app development technologies and innovative approaches.',
          }}
          contactPopup={contactPopup}
          setContactPopup={setContactPopup}
        />
      </div>
      <FaqSection
        data={{
          title: 'FAQs',
          subTitle:
            'Do you have questions regarding our mobility services? We’re happy to hear you out and we have offered some Frequently Asked Questions below for your quick reference.',
        }}
      />
      <ContactUsSection
        data={{
          title: 'Hi! Ping Us',
          subTitle: 'Contacting us is the first step towards success.',
        }}
      />
      <ContactInformation
        data={{
          title: 'Regional Contact Info',
          subTitle: 'We can give you the Wings to Fly. Contact us now!',
        }}
      />
      {PageUrlCheck && (
        <ContactModal isOpen={show} onClose={() => setShow(false)} />
      )}
      {/* 
        <Modal
          show={show}
          onHide={formModalhandleClose}
          className="form_modal contact_modal_wrap"
          centered
        >
          <Row className="justify-content-start">
            <Col xl={6}>
              <div className="modal_left_side_wrap">
                <Image
                  width={380}
                  height={70}
                  src="./assets/images/logo.svg"
                  className="img-fluid"
                  alt="Webclues Infotech"
                  data-aos="zoom-in"
                  data-aos-delay="100"
                  data-aos-easing="ease-out-quart"
                  data-aos-duration="700"
                />
                <TitleH3
                  className="mb-2 text_white"
                  text="We'd Love to Hear From You, Drop Us a Line"
                />
                <div className="links color-white">
                  <a
                    className="link"
                    href="mailto:sales@webcluesinfotech.com"
                    title="Mail"
                  >
                    <div className="icon">
                      <img
                        src="assets/images/ecommerce-development-company/icons/email.svg"
                        alt="📨"
                        className="decoration"
                        draggable="false"
                        loading="lazy"
                      />
                    </div>
                    <div className="label">sales@webcluesinfotech.com</div>
                  </a>

                  <a className="link" href="tel:+918141068282" title="Call">
                    <div className="icon">
                      <img
                        src="assets/images/ecommerce-development-company/icons/phone.svg"
                        alt="📞"
                        className="decoration"
                        draggable="false"
                        loading="lazy"
                      />
                    </div>
                    <div className="label">webcluesinfotech</div>
                  </a>
                  <a className="link" href="tel:+918141068282" title="Call">
                    <div className="icon">
                      <img
                        src="assets/images/ecommerce-development-company/icons/phone.svg"
                        alt="📞"
                        className="decoration"
                        draggable="false"
                        loading="lazy"
                      />
                    </div>
                    <div className="label">For Sales: +91-814-106-8282</div>
                  </a>
                  <a className="link" href="tel:+19783099910" title="Call">
                    <div className="icon">
                      <img
                        src="assets/images/ecommerce-development-company/icons/phone.svg"
                        alt="📞"
                        className="decoration"
                        draggable="false"
                        loading="lazy"
                      />
                    </div>
                    <div className="label">USA: +1-(978)-309-9910</div>
                  </a>
                  <a className="link" href="tel:+971502578857" title="Call">
                    <div className="icon">
                      <img
                        src="assets/images/ecommerce-development-company/icons/phone.svg"
                        alt="📞"
                        className="decoration"
                        draggable="false"
                        loading="lazy"
                      />
                    </div>
                    <div className="label">UAE: +971-50-257-8857</div>
                  </a>
                  <a className="link" href="tel:+44-776-841-8141" title="Call">
                    <div className="icon">
                      <img
                        src="assets/images/ecommerce-development-company/icons/phone.svg"
                        alt="📞"
                        className="decoration"
                        draggable="false"
                        loading="lazy"
                      />
                    </div>
                    <div className="label">UK: +44-776-841-8141</div>
                  </a>
                  <a className="link" href="tel:+61480193028" title="Call">
                    <div className="icon">
                      <img
                        src="assets/images/ecommerce-development-company/icons/phone.svg"
                        alt="📞"
                        className="decoration"
                        draggable="false"
                        loading="lazy"
                      />
                    </div>
                    <div className="label">AUS: +61-480-193-028</div>
                  </a>
                  <a className="link" href="tel:+16479497499" title="Call">
                    <div className="icon">
                      <img
                        src="assets/images/ecommerce-development-company/icons/phone.svg"
                        alt="📞"
                        className="decoration"
                        draggable="false"
                        loading="lazy"
                      />
                    </div>
                    <div className="label">Canada: +1-647-949-7499</div>
                  </a>
                </div>
              </div>
            </Col>
            <Col xl={6}>
              <Modal.Header closeButton className="border-0 pb-1" />
              <Modal.Body className="pt-0">
                <section className="contactform_new form_modal_contactform">
                  <Container fluid>
                    <Row className="justify-content-start">
                      <Col xl={12}>
                        <TitleH3
                          className="mb-2 text_black"
                          text="Looking for the right partner for your next technology project?"
                        />
                        <SubText
                          className="text_black"
                          text="Get In touch with us today"
                        />
                        <div className="mt-4">
                          <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="d-flex" />
                            <Row>
                              <Col xl={12} className="mb-2">
                                <Form.Group className="mb-2">
                                  <Form.Control
                                    type="text"
                                    placeholder="Your Name *"
                                    className="bg-transparent"
                                    {...register('yourName', {
                                      required: true,
                                      maxLength: 80,
                                    })}
                                  />
                                  <p className="alert-error">
                                    {errors.yourName && (
                                      <span>{errors.yourName.message}</span>
                                    )}
                                  </p>
                                </Form.Group>
                              </Col>
                              <Col xl={12} className="mb-2">
                                <Form.Group className="mb-2">
                                  <Form.Control
                                    type="text"
                                    placeholder="Your Email *"
                                    className="bg-transparent"
                                    {...register('yourEmail', {
                                      required: true,
                                      pattern: /^\S+@\S+$/i,
                                    })}
                                  />
                                  <p className="alert-error">
                                    {errors.yourEmail && (
                                      <span>{errors.yourEmail.message}</span>
                                    )}
                                  </p>
                                </Form.Group>
                              </Col>
                              <Col xl={12} className="mb-2">
                                <Form.Group className="mb-2">
                                  <Controller
                                    name="phoneInput"
                                    control={control}
                                    render={({
                                      field: { onChange, value },
                                    }) => (
                                      <PhoneInput
                                        value={value}
                                        onChange={(e: any) => onChange(e)}
                                        defaultCountry={phoneCountryCode}
                                        id="phoneInput"
                                        className="form-control d-flex border-disable bg-transparent"
                                        placeholder="Contact Number"
                                      />
                                    )}
                                  />
                                  <p className="alert-error">
                                    {errors.phoneInput && (
                                      <span>{errors.phoneInput.message}</span>
                                    )}
                                  </p>
                                </Form.Group>
                              </Col>
                              <Col xl={12} className="mb-2">
                                <Form.Group className="mb-2">
                                  <Form.Control
                                    type="text"
                                    placeholder="Skype ID"
                                    className="bg-transparent"
                                    {...register('skypeID', {})}
                                  />
                                </Form.Group>
                              </Col>
                              <Col xl={12} className="mb-2 pt-3">
                                <Form.Control
                                  as="textarea"
                                  className="py-0 border-disable bg-transparent"
                                  placeholder="Project Requirements *"
                                  {...register('projectRequirements', {
                                    required: true,
                                  })}
                                  rows={4}
                                />
                                <p className="alert-error">
                                  {errors.projectRequirements && (
                                    <span>
                                      {errors.projectRequirements.message}
                                    </span>
                                  )}
                                </p>
                              </Col>
                              <Col xl={12} className="">
                                <div className="form-group">
                                  <input type="checkbox" id="html" />
                                  <label htmlFor="html">
                                    We respect your privacy and do not tolerate
                                    spam and will never sell rent lease or give
                                    away your information (name, address, email,
                                    etc) to any third party. Nor will we send
                                    you unsolicited email.
                                  </label>
                                </div>
                              </Col>
                              <Col xl={12} className="mt-4">
                                <Button className="btn-black" type="submit">
                                  <span>Send</span> <span>Request</span>
                                </Button>
                              </Col>

                              <p className="text_para pt-2 pe-0 pe-xl-5 me-0 me-lg-5 alert-successfully">
                                {SuccessMesg}
                              </p>
                              <p className="text_para pt-2 pe-0 pe-xl-5 me-0 me-lg-5 alert-error">
                                {ErrorMesg}
                              </p>
                            </Row>
                          </form>
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </section>
              </Modal.Body>
            </Col>
          </Row>
        </Modal>
      */}
    </>
  )
}

export default TechnologyPage
